export const ZOOM_FACTOR = 0.001;
export const ZOOM_FACTOR_TOUCH = 0.01
export const MIN_ZOOM = 0.1;
export const MAX_ZOOM = 120;
